<template>
	<div id="nnconfigurator" class="nnc-root">
		<router-view></router-view>
	</div>
</template>


<script>

import { BootService } from '@/services/boot.service'
import { EventBus } from '@/common/eventbus.js'
import { mapState } from 'vuex'
import { ApiService } from '@/services/api.service'
import { Log } from '@/services/log.service'

import { store } from '@/store'
import router from '@/router'
require('vue2-animate/dist/vue2-animate.min.css')

export default {
	router,
	store,
	name: 'App',
	
	computed: {
		...mapState('globals', ['app', 'animation']),
		...mapState('settings', ['presets']),
	},

	mounted () {
		this.setLanguage();
		this.$nextTick( this.boot );
	},
	
	methods: {
		
		/**
		 * 	Sprache setzen
		 * 
		 */
		setLanguage() {
			this.$store.commit('globals/SET_LANGUAGE', this.$el.parentNode.dataset.lang);
			this.$store.commit('globals/SET_LANGUAGE_UID', this.$el.parentNode.dataset.langUid);
			this.$store.commit('configurator/SET_PRESELECT', ApiService.parseJsonString(this.$el.parentNode.dataset.preselect));
		},

		/**
		 * 	App starten
		 * 
		 */
		boot() {
			
			// Splash-Screen zeigen
			this.$router.replace('/preloader').catch((err)=>{});

			// App booten, Settings laden, Root-Page laden...
			BootService.init().then( ({ data }) => {

				// Adobe Animate Assets laden
				this.loadAdobeAnimateAssets().then( ({ref, e}) => {

					this.$store.commit('globals/SET_ANIMATION', ref);

					Log.SUCCESS('App.vue', 'boot() animation:', this.animation);

					// App ist startklar.
					this.$router.push('/index')

				});

			});
		},

		/**
		 * 	Adobe-Animate auf Canvas laden
		 */
		loadAdobeAnimateAssets() {
			return new Promise((resolve, reject) => {
				$('.nnconfigurator-show .animate-canvas-box').on('aa.initialized', function ( e, ref ) {
					resolve({e:e, ref:ref});
				});
				$('.nnconfigurator-show .animate-canvas-box').adobeAnimation();
			});
		}
	}
}
</script>

<style scoped lang="scss">
	.nnc-root {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue